import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class NotificationLoader extends Loader {}

export const notificationLoader = new NotificationLoader({
  service: SERVICES.notification,
})
